<div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content">
            <img src="assets/images/loader/SecuLoaderBlack.gif" style="height: 70px;display: block;margin: auto;">
            <!-- <div>Processing...</div> -->
        </div>
    </div>
</div>